import { configureStore } from '@reduxjs/toolkit'
import { commonReducer, productReducer } from './Reducers'

export const store = configureStore({
  reducer: {
    common:commonReducer,
    product:productReducer
  },
})